import { IStoreState } from "App/types";
import { has } from "lodash-es";

export const isPageFetchedInState = (
  state: IStoreState,
  paginationKey: string,
  page: number
) => {
  const pageFetched = has(state, [
    "data",
    "pagination",
    paginationKey,
    "pages",
    page,
  ]);

  return pageFetched;
};
